import React from 'react';
import Link from 'next/link';
import { H2 } from './text';
import { PlayerCard } from './player-card';
import { IPlayer } from '../models/player';

interface PlayerListProps {
	coaches: IPlayer[];
	goalkeepers: IPlayer[];
	defenders: IPlayer[];
	midfielders: IPlayer[];
	attackers: IPlayer[];
}

const SquadCardList: React.FC<PlayerListProps> = ({ coaches, goalkeepers, defenders, midfielders, attackers }) => {
	return (
		<article className="mb-8 player-list">
			{coaches && coaches.length > 0 && (
				<section className="mb-12">
					<H2 className="text-left mb-4">Trainers</H2>
					<div className="flex flex-col items-center sm:grid sm:grid-flow sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
						{coaches.map((player) => (
							<PlayerCard key={player.passport.id} player={player} />
						))}
					</div>
				</section>
			)}

			{goalkeepers && goalkeepers.length > 0 && (
				<section className="mb-12">
					<H2 className="text-left mb-4">Keepers</H2>
					<div className="flex flex-col items-center sm:grid sm:grid-flow sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
						{goalkeepers.map((player) => (
							<Link href={`/spelers/${player.slug}`} key={player.passport.id}>
								<PlayerCard player={player} />
							</Link>
						))}
					</div>
				</section>
			)}

			{defenders && defenders.length > 0 && (
				<section className="mb-12">
					<H2 className="text-left mb-4">Verdedigers</H2>
					<div className="flex flex-col items-center sm:grid sm:grid-flow sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
						{defenders.map((player) => (
							<Link href={`/spelers/${player.slug}`} key={player.passport.id}>
								<PlayerCard player={player} />
							</Link>
						))}
					</div>
				</section>
			)}

			{midfielders && midfielders.length > 0 && (
				<section className="mb-12">
					<H2 className="text-left mb-4">Middenvelders</H2>
					<div className="flex flex-col items-center sm:grid sm:grid-flow sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
						{midfielders.map((player) => (
							<Link href={`/spelers/${player.slug}`} key={player.passport.id}>
								<PlayerCard player={player} />
							</Link>
						))}
					</div>
				</section>
			)}

			{attackers && attackers.length > 0 && (
				<section className="mb-12">
					<H2 className="text-left mb-4">Aanvallers</H2>
					<div className="flex flex-col items-center sm:grid sm:grid-flow sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
						{attackers.map((player) => (
							<Link href={`/spelers/${player.slug}`} key={player.passport.id}>
								<PlayerCard player={player} />
							</Link>
						))}
					</div>
				</section>
			)}
		</article>
	);
};

export default SquadCardList;
